import { createReducer } from 'deox';
import { Paging, Country } from '@/types';
import env from '@/env';
import { fetchRegionsActions, fetchCountriesByRegionActions } from '@/redux/actions/country-information/regions';

export interface RegionsState {
  regions: {
    data?: {
      label: string;
      value: string;
    }[];
    paging: Paging;
  };
  countries: {
    data?: {
      label: any;
      value: string;
      flag: string;
      code: string;
    }[];
    paging: Paging;
    meta: {
      authors: string[];
    };
  };
}

const initialState: RegionsState = {
  regions: {
    data: undefined,
    paging: {
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0,
    },
  },
  countries: {
    data: undefined,
    paging: {
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0,
    },
    meta: {
      authors: [],
    },
  },
};

const countryInformationRegionsReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchRegionsActions.success, (state, { payload }) => {
    const { data, paging } = payload;
    const beautifyRegions = data.map((region) => ({ label: region, value: region }));
    return {
      ...state,
      regions: {
        data: beautifyRegions,
        paging,
      },
    };
  }),
  handleAction(fetchCountriesByRegionActions.success, (state, { payload }) => {
    const { data, paging, meta } = payload;
    const beautifyCountries = data.map((country: Country) => ({
      label: country.attributes.name,
      value: country.attributes.code2,
      flag: `${env.api.baseUrl.staticAssets}/${country.attributes.flagUrlRound}_92.png`,
      code: country.attributes.code2,
    }));
    return {
      ...state,
      countries: {
        data: beautifyCountries,
        paging,
        meta,
      },
    };
  }),
]);

export default countryInformationRegionsReducer;
